export default __webpack_public_path__ + "static/media/Rule3.72991104.png";